import axiosInstance from './config/api';

export interface CallTranscriptSpeech {
    speaker: string;
    text: string;
    timestamp_ns: number;
    order: number;
}

export interface CallTranscript {
    sender: string;
    text: string;
    speeches: CallTranscriptSpeech[];
}

export const getCallTranscript = (callId: string) => {
    return axiosInstance
        .get<CallTranscript>(`/workflows/transcripts/${callId}`, {
            suppressErrorToast: true,
        })
        .then((res) => res.data);
};
